export default "__VITE_ASSET__C4M9MyDj__"